import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const LOGO_MASK_URL = `${process.env.PUBLIC_URL}/poppygrid-logo.svg`;

const NAV_LINKS = [
  { to: '/', label: 'Home', match: (path) => path === '/' },
  { to: '/for-businesses', label: 'For Businesses', match: (path) => path === '/for-businesses' },
  { to: '/contact', label: 'Contact / Book Demo', match: (path) => path === '/contact' },
  { to: '/terms', label: 'Terms', match: (path) => path === '/terms' },
  { to: '/privacy', label: 'Privacy', match: (path) => path === '/privacy' },
  {
    to: '/community-guidelines',
    label: 'Guidelines',
    match: (path) => path === '/community-guidelines',
  },
];

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo" aria-label="PoppyGrid home">
          <span
            className="logo-brand"
            aria-hidden="true"
            style={{ '--logo-mask': `url("${LOGO_MASK_URL}")` }}
          />
        </Link>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="main-nav"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
        </button>

        <nav
          id="main-nav"
          className={`nav ${menuOpen ? 'nav--open' : ''}`}
          aria-label="Main navigation"
        >
          {NAV_LINKS.map(({ to, label, match }) => (
            <Link
              key={to}
              to={to}
              className={`nav-link ${match(location.pathname) ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
      {menuOpen && (
        <button
          type="button"
          className="nav-backdrop"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </header>
  );
}

export default Header;
